import React from 'react'
import Sidebar from '../components/_sidebar'
import { Container } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

export default (props) => {

  return (
    <div className="container">
      <Sidebar>
        <Container>
        <h3 className="mb-4"><FormattedMessage id="faqs"/></h3>
          <div dangerouslySetInnerHTML={{__html: props.data.html.html}}></div>          
        </Container>
      </Sidebar>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/pages/about/faqs/_faqsLayout.js